import type { IconData } from '@stacksjs/iconify-core'

export const contentFilesArchiveBooks3: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M28.96 13.72V9.14h-1.53v1.53h-3.04V7.62h1.52V6.1h-3.05V3.05h-1.52V0H4.58v1.52H1.53v12.2H0V32h32V13.72Zm-6.1-6.1v4.57h4.57v1.53H15.24v-6.1ZM3.05 3.05h1.53v10.67H3.05Zm6.1 15.24H7.62v1.52H4.58v-1.52H3.05v-1.53h6.1Zm0-4.57H6.1V1.52h13.71v1.53H9.15Zm1.52-9.15h10.67V6.1h-7.62v7.62h-3.05Zm19.81 25.91H12.2V15.24h18.28Z\"/><path fill=\"currentColor\" d=\"M27.43 22.86h1.53v1.52h-1.53Zm-7.62 4.57h9.15v1.52h-9.15Zm6.1-19.81h1.52v1.52h-1.52Zm-3.05 16.76h3.05v1.53h-3.05Zm-3.05-1.52h1.53v1.52h-1.53Z\"/>",
  "width": 32,
  "height": 32,
  "viewBox": "0 0 32 32"
}

export default contentFilesArchiveBooks3
